<template>
  <form @submit.prevent="submit">
    <base-card :closed="closed" handler="collapseProjectValuer" collapsible hide-caret>
      <template v-slot:header>
        <base-card-heading>
          Valuer Details
        </base-card-heading>
        <base-button secondary small :submit="!closed" @click="handle">
          {{ closed ? 'View & Edit' : 'Save & Close' }}
        </base-button>
      </template>
      <div class="row">
        <div class="col-sm-6">
          <base-field label="Contact Name">
            <base-input v-model="payload.name" placeholder="name" />
          </base-field>
        </div>
        <div class="col-sm-6">
          <base-field label="Email Address">
            <base-input v-model="payload.email" placeholder="email" type="email" />
          </base-field>
        </div>
        <div class="col-sm-6">
          <base-field label="Firm">
            <base-input v-model="payload.company" placeholder="firm" />
          </base-field>
        </div>
        <div class="col-sm-6">
          <base-field label="Telephone">
            <base-input v-model="payload.phone" placeholder="telephone" type="tel" />
          </base-field>
        </div>
      </div>
    </base-card>
  </form>
</template>

<script>
import { mapState } from 'vuex'

export default {
  created () {
    this.payload = this.$_.clone(this.project.valuer)
  },

  data () {
    return {
      closed: true,
      payload: {},
      saving: false
    }
  },

  name: 'ProjectValuer',

  computed: {
    ...mapState({
      project: store => store.core.projects.entity
    })
  },

  methods: {
    async handle () {
      if (!this.closed) {
        await this.submit()
      } else {
        this.closed = false
      }
    },

    async submit () {
      this.saving = true

      await this.$store.dispatch('core/projects/save', {
        _id: this.project._id,
        valuer: this.payload
      })

      this.$flash.success('Valuer details successfully saved.')

      this.closed = true
      this.saving = false
    }
  }
}
</script>
